// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmPropertiesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AccountViewExpandedPropertyUnitsResponseDto,
  AccountViewPropertiesResponseDto,
  AccountViewPropertyAddedResponseDto,
  AccountViewPropertyOptionsResponseDto,
  ListingAlias,
} from '../..';

interface AddedParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId?: string;
}
interface ListParams {
  includeArchived?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  groupId: string;
  isArchiveView?: boolean;
}
interface UnitsParams {
  groupId: string;
  includeArchived?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_added_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/properties/added';

/**
 * Get the property summary and next actions for the property-added success screen
 */
export const RentalManagerAccountViewZrmPropertiesWebApiHandler_added = (
  getParams: AddedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AddedParams, never, AccountViewPropertyAddedResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertiesWebApiHandler_added_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_list_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/properties/list';

/**
 * Get zrm user property table properties view
 */
export const RentalManagerAccountViewZrmPropertiesWebApiHandler_list = (
  getParams: ListParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ListParams, never, AccountViewPropertiesResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertiesWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/properties/options';

/**
 * Get zrm user property table row options for a property
 */
export const RentalManagerAccountViewZrmPropertiesWebApiHandler_options = (
  getParams: OptionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OptionsParams, never, AccountViewPropertyOptionsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_units_Path =
  '/api/web/v2/users/accountView/zrm/propertyTable/properties/units';

/**
 * Get zrm user property table units for a property
 */
export const RentalManagerAccountViewZrmPropertiesWebApiHandler_units = (
  getParams: UnitsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UnitsParams, never, AccountViewExpandedPropertyUnitsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmPropertiesWebApiHandler_units_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
